import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '2.5rem' }}>
    <h2 style={{
      fontFamily: "'Sora', sans-serif",
      fontSize: 'clamp(1.1rem,2vw,1.35rem)',
      fontWeight: 700,
      color: '#ffffff',
      marginBottom: '1rem',
      paddingBottom: '0.75rem',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
    }}>
      {title}
    </h2>
    <div style={{
      fontFamily: "'Inter', sans-serif",
      color: 'rgba(156,163,175,0.7)',
      fontSize: '0.9rem',
      lineHeight: 1.8,
    }}>
      {children}
    </div>
  </div>
);

const PrivacyPolicy = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#030712', color: '#fff' }}>
      <Navbar />
      <main style={{ padding: 'clamp(1.25rem,5vw,5rem)', paddingTop: '100px', paddingBottom: '5rem' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div style={{
              display: 'inline-block',
              padding: '0.25rem 0.875rem',
              borderRadius: '100px',
              background: 'rgba(30,144,255,0.1)',
              border: '1px solid rgba(30,144,255,0.2)',
              fontFamily: "'Sora', sans-serif",
              fontSize: '0.65rem',
              fontWeight: 700,
              color: '#1E90FF',
              textTransform: 'uppercase',
              letterSpacing: '0.25em',
              marginBottom: '1.5rem',
            }}>
              Legal
            </div>

            <h1 style={{
              fontFamily: "'Sora', sans-serif",
              fontSize: 'clamp(2rem,5vw,3.5rem)',
              fontWeight: 800,
              letterSpacing: '-0.5px',
              lineHeight: 1.1,
              marginBottom: '0.75rem',
            }}>
              Privacy Policy
            </h1>

            <p style={{
              fontFamily: "'Inter', sans-serif",
              color: 'rgba(156,163,175,0.5)',
              fontSize: '0.85rem',
              marginBottom: '3rem',
            }}>
              Last updated: May 21, 2026 — Zynqora Edge, Islamabad, Pakistan
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <Section title="1. Overview">
              <p>Zynqora Edge ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit <strong style={{ color: 'rgba(255,255,255,0.8)' }}>www.zynqoraedge.com</strong> or use our services.</p>
            </Section>

            <Section title="2. Information We Collect">
              <p style={{ marginBottom: '0.75rem' }}>We may collect the following types of information:</p>
              <ul style={{ paddingLeft: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <li><strong style={{ color: 'rgba(255,255,255,0.75)' }}>Contact form submissions:</strong> name, email address, and message content you provide when reaching out to us.</li>
                <li><strong style={{ color: 'rgba(255,255,255,0.75)' }}>Analytics data:</strong> anonymized usage data including pages visited, time on site, browser type, and device information collected via analytics tools.</li>
                <li><strong style={{ color: 'rgba(255,255,255,0.75)' }}>Cookies:</strong> small data files stored on your device that help us understand site usage and improve your experience.</li>
                <li><strong style={{ color: 'rgba(255,255,255,0.75)' }}>AI chatbot interactions:</strong> conversation data when you use any AI-powered chat features on our site, used solely to provide and improve the service.</li>
              </ul>
            </Section>

            <Section title="3. How We Use Your Information">
              <ul style={{ paddingLeft: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <li>To respond to your inquiries and provide requested services</li>
                <li>To improve our website functionality and user experience</li>
                <li>To analyze website traffic and usage patterns (analytics)</li>
                <li>To send project-related communications (only with your consent)</li>
                <li>To comply with applicable laws and legal obligations</li>
              </ul>
            </Section>

            <Section title="4. Cookies">
              <p>We use essential and analytics cookies. Essential cookies are required for the website to function. Analytics cookies help us understand how visitors interact with our site. You may disable cookies in your browser settings, though this may affect site functionality.</p>
            </Section>

            <Section title="5. AI Chatbot Usage">
              <p>Our website may feature AI-powered chat tools. Conversations through these tools are processed to provide responses and may be reviewed to improve AI system quality. We do not sell or share chatbot conversation data with third parties for marketing purposes.</p>
            </Section>

            <Section title="6. Data Handling & Retention">
              <p>We store contact form data securely and retain it only as long as necessary to respond to your inquiry or maintain our business relationship. Analytics data is retained in aggregated, anonymized form. You may request deletion of your personal data by contacting us directly.</p>
            </Section>

            <Section title="7. Third-Party Services">
              <p>We may use third-party services including analytics platforms, email infrastructure, and AI APIs. These services operate under their own privacy policies. We ensure any third parties we work with maintain appropriate data protection standards.</p>
            </Section>

            <Section title="8. Your Rights">
              <p>You have the right to access, correct, or delete personal information we hold about you. To exercise these rights, contact us at <strong style={{ color: '#1E90FF' }}>haris@harisbuilds.com</strong>.</p>
            </Section>

            <Section title="9. Contact">
              <p>
                For any privacy-related questions:<br/>
                <strong style={{ color: 'rgba(255,255,255,0.75)' }}>Zynqora Edge</strong><br/>
                Islamabad HQ &amp; Global Operations<br/>
                Email: <strong style={{ color: '#1E90FF' }}>haris@harisbuilds.com</strong><br/>
                Phone: +1 239 517 7689
              </p>
            </Section>

            <div style={{
              marginTop: '3rem',
              paddingTop: '2rem',
              borderTop: '1px solid rgba(255,255,255,0.06)',
              display: 'flex',
              gap: '1rem',
              flexWrap: 'wrap',
            }}>
              <Link to="/" style={{ color: '#1E90FF', fontFamily: "'Sora', sans-serif", fontSize: '0.85rem', fontWeight: 600, textDecoration: 'none' }}>← Back to Home</Link>
              <Link to="/terms-and-conditions" style={{ color: 'rgba(156,163,175,0.5)', fontFamily: "'Sora', sans-serif", fontSize: '0.85rem', textDecoration: 'none' }}>Terms & Conditions →</Link>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;